module.exports = {
    tag: 'dove',
    quality: 0.2,
    learning: -3,
    speed: 0.5
};